import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const GlobalHeader = () => {
    const initScrollTrigger = () => {
        const headerWrapper = document.getElementById('js-global-header-wrapper');
        const navFlyOut = document.getElementById('js-global-nav-flyout-container');
        if (headerWrapper) {
            ScrollTrigger.create({
                trigger: '#js-trigger',
                start: 'top 200px', // Adjust as necessary
                markers: false,
                onEnter: () => {
                    headerWrapper.classList.add('compact');
                    if (navFlyOut)
                        navFlyOut.classList.remove('active');
                },
                onLeaveBack: () => {
                    headerWrapper.classList.remove('compact')
                    if (navFlyOut)
                        navFlyOut.classList.remove('active');
                },
            });
        }
    };

    return {
        initScrollTrigger,
    };
};

export default GlobalHeader;
